import { mapGetters } from "vuex";
import describeDocument from "@/data/describe/mixins/describeDocument";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
// import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [
    describeDocument,
    docLogFunctions
    // createFirebase
  ],
  computed: {
    ...mapGetters([
      "getUser",
      "getPageInfo",
      "getUserDID",
      "getCompanyDID",
      "getFacilityDID"
    ])
  },
  methods: {
    updateUserStatsNewDoc(doc) {
      let tag = doc.basic.tag;
      let n = this.defineDocumentFromTag(tag).n;
      this.changeFirebaseStatsRemote("U1", this.getUserDID, n, 1, true);
      // HELP
      // console.log("");
      // console.log(">>> UPDATE USER STATS - NEW DOC. <<<");
      // console.log("DOC. TAG: " + tag);
      // console.log("DOC. CTR: " + n);
      // console.log("USER DID: " + this.getUserDID);
    },
    updateUserStatsCloseDoc(doc) {
      let tag = doc.basic.tag;
      let n = this.defineDocumentFromTag(tag).no;
      this.changeFirebaseStatsRemote("U1", this.getUserDID, n, 1, false);
      // HELP
      // console.log("");
      // console.log(">>> UPDATE USER STATS - CLOSE DOC. <<<");
      // console.log("DOC. TAG: " + tag);
      // console.log("DOC. CTR: " + n);
      // console.log("USER DID: " + this.getUserDID);
    },
    updateCompanyStatsNewDoc(doc) {
      let tag = doc.basic.tag;
      let n = this.defineDocumentFromTag(tag).n;
      if (
        tag === "B1" ||
        tag === "B3" ||
        tag === "B4" ||
        tag === "B6" ||
        tag === "E1" ||
        tag === "E2" ||
        tag === "E6" ||
        tag === "F1" ||
        tag === "L1" ||
        tag === "M2" ||
        tag === "Q1" ||
        tag === "S1" ||
        tag === "S6" ||
        tag === "W6"
      ) {
        this.changeFirebaseStatsRemote("C1", this.getCompanyDID, n, 1, true);
        // HELP
        // console.log("");
        // console.log(">>> UPDATE COMPANY STATS - NEW DOC. <<<");
        // console.log("DOC. TAG: " + tag);
        // console.log("DOC. CTR: " + n);
        // console.log("COMP DID: " + this.getCompanyDID);
      }
    },
    updateCompanyStatsCloseDoc(doc) {
      let tag = doc.basic.tag;
      let n = this.defineDocumentFromTag(tag).no;
      this.changeFirebaseStatsRemote("C1", this.getCompanyDID, n, 1, false);
      // HELP
      // console.log("");
      // console.log(">>> UPDATE COMPANY STATS - CLOSE DOC. <<<");
      // console.log("DOC. TAG: " + tag);
      // console.log("DOC. CTR: " + n);
      // console.log("USER DID: " + this.getCompanyDID);
    },
    updateFacilityStatsNewDoc(doc) {
      let tag = doc.basic.tag;
      let n = this.defineDocumentFromTag(tag).n;
      // eslint-disable-next-line
      if (
        tag === "A1" ||
        tag === "M5" ||
        tag === "O1" ||
        tag === "W1"
      ) {
        this.changeFirebaseStatsRemote("F1", this.getFacilityDID, n, 1, true);
      }
      if (tag === "M7") {
        // eslint-disable-next-line
        // this.changeFirebaseStatsRemote("F1", this.getFacilityDID, "nm7", 1, true);
        let n = this.defineDocumentFromTag("W2").n;
        let ctr = doc.stats.na1;
        // eslint-disable-next-line
        this.changeFirebaseStatsRemote("F1", this.getFacilityDID, n, ctr, true);
      }
      // HELP
      // console.log("");
      // console.log(">>> UPDATE FACILITY STATS - NEW DOC. <<<");
      // console.log("DOC. TAG: " + tag);
      // console.log("DOC. CTR: " + n);
      // console.log("FATY DID: " + this.getFacilityDID);
    },
    updateFacilityStatsCloseDoc(doc) {
      let tag = doc.basic.tag;
      let n = this.defineDocumentFromTag(tag).no;
      this.changeFirebaseStatsRemote("F1", this.getFacilityDID, n, 1, false);
      // HELP
      // console.log("");
      // console.log(">>> UPDATE COMPANY STATS - CLOSE DOC. <<<");
      // console.log("DOC. TAG: " + tag);
      // console.log("DOC. CTR: " + n);
      // console.log("USER DID: " + this.getFacilityDID);
    }
  }
};
